"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const constants_1 = require("@/constants");
/**
 * 모든 페이지의 본문 셸. main 랜드마크가 되어 상단 여백·좌우 패딩·최소 높이를 소유한다.
 * 상단 바나 푸터는 이 안이 아니라 형제로 둔다.
 * 사이드바가 열릴 때 밀려나는 폭은 body가 노출하는 `--sidebar-content-shift`를 따르며,
 * 스스로 가운데 정렬되는 width·layout 변형은 그 대신 기본 좌우 패딩으로 되돌린다.
 * `layout="split"`은 첫 자식(mm-page-header 또는 이를 묶은 레이아웃)을 왼쪽 칼럼에 sticky로 두고 나머지 콘텐츠를 오른쪽에 둔다.
 * 칼럼 간격은 좌우 패딩과 같아, 오른쪽 칼럼의 콘텐츠 프레임이 패딩만큼 바깥으로 나와도 왼쪽 칼럼과 겹치지 않는다.
 * 좁은 폭에서는 한 칼럼으로 접히며 sticky도 풀린다.
 */
let Main = class Main extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.width = '';
        this.layout = '';
        this.background = '';
        this.fullWidth = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'main');
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
Main.styles = (0, lit_1.css) `
    :host {
      --main-padding-left: var(--sidebar-content-shift);

      display: block;
      min-height: calc(100vh - var(--navbar-height));
      padding: var(--layout-main-space-top) var(--layout-padding-inline) calc(var(--space-4) * 6);
      padding-left: var(--main-padding-left);
      box-sizing: border-box;
      background-color: var(--background-color);
      position: relative;
      transition: padding-left var(--transition-duration) var(--transition-easing);
    }

    :host([background='subtle']) {
      background-color: var(--background-subtle-color);
      box-shadow: 0 0 0 100vmax var(--background-subtle-color);
      clip-path: inset(0 -100vmax);
    }

    :host([full-width]) {
      --main-padding-left: 0;

      padding-right: 0;
    }

    :host([width='small']),
    :host([width='narrow']) {
      --main-padding-left: var(--layout-padding-inline);

      max-width: var(--layout-width-small);
      margin: 0 auto;
      box-sizing: content-box;
    }

    :host([width='narrow']) {
      max-width: var(--layout-width-narrow);
    }

    :host([layout='chat']) {
      display: flex;
      flex-direction: column;
      height: calc(100vh - var(--navbar-height));
      padding: 0;
      overflow: hidden;
    }

    :host([layout='chat']) ::slotted(mm-chat-room) {
      flex: 1;
      min-height: 0;
    }

    :host([layout='split']) {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: var(--layout-padding-inline);
    }

    :host([layout='split']) ::slotted(:first-child) {
      align-self: start;
      position: sticky;
      top: calc(var(--navbar-height) + var(--layout-main-space-top));
    }

    @media ${constants_1.MEDIA.narrow} {
      :host([layout='split']) {
        grid-template-columns: minmax(0, 1fr);
      }

      :host([layout='split']) ::slotted(:first-child) {
        position: static;
      }
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Main.prototype, "width", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Main.prototype, "layout", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Main.prototype, "background", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, attribute: 'full-width', reflect: true })
], Main.prototype, "fullWidth", void 0);
Main = __decorate([
    (0, decorators_js_1.customElement)('mm-main')
], Main);
exports.Main = Main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFpbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1haW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCwyQ0FBbUM7QUFFbkM7Ozs7Ozs7O0dBUUc7QUFFSSxJQUFNLElBQUksR0FBVixNQUFNLElBQUssU0FBUSxnQkFBVTtJQUE3Qjs7UUEyRXNDLFVBQUssR0FBNEIsRUFBRSxDQUFBO1FBQ25DLFdBQU0sR0FBMEIsRUFBRSxDQUFBO1FBQ2xDLGVBQVUsR0FBa0IsRUFBRSxDQUFBO1FBQ0osY0FBUyxHQUFHLEtBQUssQ0FBQTtJQVl4RixDQUFDO0lBVkMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDbkMsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDOztBQXhGTSxXQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7YUFnRVIsaUJBQUssQ0FBQyxNQUFNOzs7Ozs7Ozs7R0FTdEIsQ0FBQTtBQUMwQztJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzttQ0FBb0M7QUFDbkM7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7b0NBQW1DO0FBQ2xDO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO3dDQUErQjtBQUNKO0lBQXBFLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7dUNBQWtCO0FBOUUzRSxJQUFJO0lBRGhCLElBQUEsNkJBQWEsRUFBQyxTQUFTLENBQUM7R0FDWixJQUFJLENBMEZoQjtBQTFGWSxvQkFBSSJ9